module.exports = __webpack_public_path__ + "static/img/user_avatar04.105c9a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_avatar04.png
// module id = RXoc
// module chunks = 1